<template>
    <div>
        <h1 class="page__title">Создать Баннер</h1>

        <div class="intro-y box p-5 mt-5">
            <form method="post" class="grid grid-cols-12 gap-6" :class="{ 'disabled-form': loading }">
                <div v-if="loading" class="absolute z-100 left-0 top-0 w-full h-full flex items-center justify-center">
                    <Preloader />
                </div>

                <div class="col-span-6">
                    <label for="form-name" class="form-label">Название<sup class="text-theme-6"> *</sup></label>
                    <input
                        id="form-name"
                        v-model="form.title"
                        type="text"
                        class="form-control w-full"
                        placeholder=""
                        autocomplete="off"
                        required
                    />
                </div>

                <div class="col-span-6">
                    <label for="form-slug" class="form-label">Код</label>
                    <input id="form-slug" v-model="form.code" type="text" class="form-control w-full" />
                </div>

                <div class="col-span-12">
                    <div class="wrap-btn-create flex items-center justify-between">
                        <div class="form-label">Слайды</div>
                        <button type="button" class="btn btn-primary" @click="createBannerItem()">
                            <PlusCircleIcon class="stroke-current" />
                        </button>
                    </div>
                    <ContentTable
                        :headers="tableExample"
                        :table-rows="getItemsSort"
                        :table-actions="tableActions"
                        @edit="editAction"
                        @delete="deleteAction"
                    />
                </div>

                <div class="col-span-12 flex items-center justify-end mt-5">
                    <router-link :to="{ name: 'content-banners' }" class="btn btn-secondary w-24 mr-2 mb-2"
                        >Отмена
                    </router-link>
                    <button type="submit" class="btn btn-primary mb-2 mr-2" @click.prevent="save(false)">
                        Сохранить и выйти
                    </button>
                    <button type="submit" class="btn btn-primary mb-2" @click.prevent="save(true)">Сохранить</button>
                </div>
            </form>
        </div>
        <ModalContainer :modal-open="modalOpen" @closeModal="closeModal">
            <template #header>
                <h2 v-if="item">Редактирование {{ item.title }}</h2>
                <h2 v-else>Создать</h2>
            </template>
            <template #body>
                <form-edit v-if="item" :item="item" @save="itemPush"></form-edit>
                <form-create v-else @save="itemPush"></form-create>
            </template>
        </ModalContainer>

        <PopupDeleteModal
            :is-open="modalDeleteOpen"
            :entity-name="modalDeleteCaption"
            :modal-data="modalDeleteRow"
            @update:isOpen="modalDeleteOpen = $event"
            @deleteModalAccepted="onDeleteModalAccepted"
        />
    </div>
</template>

<script>
import { errorResponse, formPreparation } from '@/mixins/form/form-mixin';
import Preloader from '@/components/preloader/Main';
import ContentTable from '@/components/tables/ContentTable';
import ModalContainer from '@/components/modals/ModalContainer';
import FormCreate from './banner-item-forms/Create';
import FormEdit from './banner-item-forms/Edit';
import PopupDeleteModal from '@/components/modals/PopupDeleteModal';

export default {
    name: 'BannerCreate',
    components: { Preloader, ContentTable, ModalContainer, FormCreate, FormEdit, PopupDeleteModal },
    mixins: [formPreparation, errorResponse],
    data() {
        return {
            loading: false,
            form: {
                title: null,
                code: null,
                items: [],
            },
            tableExample: [
                { field: 'index', label: 'Порядковый номер' },
                { field: 'title', label: 'Название' },
            ],
            tableActions: [
                { name: 'edit', title: 'редактировать', icon: 'Edit2Icon', cbName: 'edit' },
                { name: 'delete', title: 'удалить', class: 'bg-red-400', icon: 'Trash2Icon', cbName: 'delete' },
            ],
            modalOpen: false,
            item: null,
            itemIndex: null,
            deleteModal: false,
            modalDeleteOpen: false,
            modalDeleteCaption: null,
            modalDeleteRow: null,
        };
    },
    computed: {
        getItemsSort() {
            return this.form.items.sort(function (a, b) {
                return a.index - b.index;
            });
        },
    },
    methods: {
        closeModal() {
            this.modalOpen = false;
            this.item = null;
            this.itemIndex = null;
        },
        createBannerItem() {
            this.modalOpen = true;
        },
        editAction(row, index) {
            this.item = row;
            this.itemIndex = index;
            this.modalOpen = true;
        },
        deleteAction(row) {
            this.modalDeleteOpen = true;
            this.modalDeleteCaption = 'баннер';
            this.modalDeleteRow = row;
            this.item = row;
            this.itemIndex = this.form.items.indexOf(row);
        },
        onDeleteModalAccepted() {
            this.form.items.splice(this.itemIndex, 1);
            this.item = null;
            this.itemIndex = null;
            this.deleteModal = false;
        },
        itemPush(item) {
            if (this.item) {
                this.form.items[this.itemIndex] = item;
            } else {
                this.form.items.push(item);
            }
            this.form.items.sort();
            this.closeModal();
        },
        async save(flag) {
            this.loading = true;
            const form = this.formPreparation({ imagesAsObject: true });

            await this.axios
                .post('/banners', form)
                .then((res) => {
                    this.loading = false;
                    if (flag) {
                        this.$router.push({ name: 'content-banners-edit', params: { id: res.data.data.id } });
                        this.$notify('Запись добавлена');
                    } else {
                        this.$router.push({ name: 'content-banners' });
                    }
                    // this.$router.push({ name: 'content-banners' });
                })
                .catch((ex) => {
                    this.errorResponse(ex);
                });
        },
    },
};
</script>

<style></style>
